import axios from 'axios'
import router from '@/router/index'
import cssVars from '../../assets/scss/base/_variables.scss'
import fn from '../../utils/functions'

function HEXtoHSL(hex) {
  hex = hex.replace(/#/g, '');
  if (hex.length === 3) {
      hex = hex.split('').map(function (hex) {
          return hex + hex;
      }).join('');
  }
  var result = /^([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})[\da-z]{0,0}$/i.exec(hex);
  if (!result) {
      return null;
  }
  var r = parseInt(result[1], 16);
  var g = parseInt(result[2], 16);
  var b = parseInt(result[3], 16);
  r /= 255;  g /= 255;  b /= 255;
  var max = Math.max(r, g, b),
      min = Math.min(r, g, b);
  var h, s, l = (max + min) / 2;
  if (max == min) {
      h = s = 0;
  } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
      case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
      case g:
          h = (b - r) / d + 2;
          break;
      case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
  }
  s = s * 100;
  s = Math.round(s);
  l = l * 100;
  l = Math.round(l);
  h = Math.round(360 * h);

  return {
      h: h,
      s: s,
      l: l
  };
}

function HSLToHex(h,s,l) {
  s /= 100;
  l /= 100;

  let c = (1 - Math.abs(2 * l - 1)) * s,
      x = c * (1 - Math.abs((h / 60) % 2 - 1)),
      m = l - c/2,
      r = 0,
      g = 0, 
      b = 0; 

  if (0 <= h && h < 60) {
    r = c; g = x;
  } else if (60 <= h && h < 120) {
    r = x; g = c;
  } else if (120 <= h && h < 180) {
    g = c; b = x;
  } else if (180 <= h && h < 240) {
    g = x; b = c;
  } else if (240 <= h && h < 300) {
    r = x; b = c;
  } else if (300 <= h && h < 360) {
    r = c; b = x;
  }
  // Having obtained RGB, convert channels to hex
  r = Math.round((r + m) * 255).toString(16);
  g = Math.round((g + m) * 255).toString(16);
  b = Math.round((b + m) * 255).toString(16);

  // Prepend 0s, if necessary
  if (r.length == 1)
    r = "0" + r;
  if (g.length == 1)
    g = "0" + g;
  if (b.length == 1)
    b = "0" + b;

  return "#" + r + g + b;
}

// state
const state = {
  local: {
    localproject: null,
    loadmenulogo: null,
    loading: false,
    isPasswordText: false,
    mqPhone: window.matchMedia('(max-width: 767px)')
  },
  forceThemeMods: true
}

// getters
const getters = {
  getLoaderState () {
    return state.local.loading
  },
  getIsMobile () {
    return state.local.mqPhone.matches
  },
  getIsPasswordForm () {
    return state.local.isPasswordText
  },
  localproject: state => {
    return state.local.localproject
  },
  loadmenulogo: state => {
    return state.local.loadmenulogo
  },
  getUsername () {
    return state.local.username
  },
  getPassword () {
    return state.local.password
  }
}

const sassMix = (color1, weight) => {
  const d2h = d => d.toString(16)
  const h2d = h => parseInt(h, 16)
  let color = '#'
  color1 = color1.replace('#', '')
  for (let i = 0; i <= 5; i += 2) {
    const v1 = h2d(color1.substr(i, 2))
    const white = h2d('ffffff'.substr(i, 2))
    let val = d2h(Math.floor(v1 + (white - v1) * (weight / 100.0)))
    while (val.length < 2) val = '0' + val
    color += val
  }
  return color
}

// actions
const actions = {
  isNewVersionLoginLocalState ({ state }, localStorage) {
    return fn.isNewVersion(state, localStorage.login)
  },

  async writeThemeColors ({ rootState, commit }) {
    // this should come from service / storage
    let clientPrimary = ''
    let clientSecondary = ''
    let clientbg = ''
    let logo = ''
    if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined) {
      // Se obtiene la personalización para el proyecto si viene por URL
      try {
        const response = await axios({
          method: 'GET',
          url: '/project/' + rootState.session.urlIn + '/personalization',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL
        })
        if (response && response.data && response.data.primaryColor && response.data.secondaryColor) {
          clientPrimary = response.data.primaryColor
          clientSecondary = response.data.secondaryColor
          logo = response.data.logo
        } else {
          // Personalización por defecto
          clientPrimary = '#2E6C99'
          clientSecondary = '#1376bd'
        }

        fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)

        if (response.data.projectName) {
          commit('URL_IN_STATE', response.data.projectName)
        }
      } catch (error) {
        console.log('ERROR --- 1 ', error.response)
        throw error.response
      }
    } else {
      if (rootState.session.primaryColor !== null && rootState.session.primaryColor !== undefined) {
        clientPrimary = rootState.session.primaryColor
        clientSecondary = rootState.session.secondaryColor
      } else {
        // Personalización por defecto
        clientPrimary = '#2E6C99'
        clientSecondary = '#1376bd'
      }
    }
    // Se obtiene el fondo a partir del color primario (añadiendo transparencia)
    if (clientPrimary !== null && clientPrimary !== undefined) {
      const colorHSL = HEXtoHSL(clientPrimary)
      clientbg = HSLToHex(colorHSL.h, colorHSL.s-5, 97)
    }

    const clientColors = { clientPrimary: clientPrimary, clientSecondary: clientSecondary, clientbg: clientbg }
    commit('PRIMARY_COLOR_STATE', clientColors.clientPrimary)
    commit('SECONDARY_COLOR_STATE', clientColors.clientSecondary)
    commit('CLIENTBG_COLOR_STATE', clientColors.clientbg)
    commit('LOAD_LOGO', logo)
    console.log('SIL colores ' + clientColors.clientPrimary + ' ' + clientColors.clientSecondary)
    document.documentElement.style.setProperty(
      '--color-bg-interactive',
      clientColors.clientPrimary
    )
    document.documentElement.style.setProperty(
      '--color-bg-interactive-soft',
      clientColors.clientSecondary
    )
    document.documentElement.style.setProperty(
      '--color-bg-hover-2',
      clientColors.clientbg
    )
    // declare objs
    const originalColors = {}
    const clientPalette = {}
    const mappedColors = {}
    // define the palette
    const weights = [0, 10, 20, 30, 40, 50, 60, 70, 87, 93]

    // get the colors from css vars, filter by name
    const colorKeys = Object.keys(cssVars).filter(k => k.includes('theme'))
    // assign colors to originalColors object
    colorKeys.forEach(k => originalColors[k] = cssVars[k]) // eslint-disable-line
    // generate the client palette: originalColors and clientColors
    weights.forEach((w, i) => clientPalette[colorKeys[i]] = sassMix(clientColors.clientPrimary, w)) // eslint-disable-line
    // manually add secondary color to clientColors
    clientPalette.themeSecondary = clientColors.clientSecondary
    // generate mappedColors object to optimize string replace
    for (const color in originalColors) mappedColors[originalColors[color]] = clientPalette[color]
    // create regexs from mappedColors
    const re = new RegExp(Object.keys(mappedColors).join('|'), 'gi')

    // declare replace function
    const replaceColors = str => str.replace(re, matched => mappedColors[matched] || mappedColors[matched.toUpperCase()])

    // dev environment
    /* if (process.env.NODE_ENV === 'development') {
      // get style strings
      let styles = document.querySelectorAll('head style')
      for (let style in styles) {
        // check str is not empty
        if (styles[style].innerHTML) {
          // replace content with new values
          styles[style].innerHTML = replaceColors(styles[style].innerHTML)
        }
      } */
    // prod - else environments
    // } else {
    // get styles href
    const styles = Array.from(document.querySelectorAll('head link')).filter(e => e.href.includes('.css'))
    const head = document.querySelector('head')
    for (let i = 0; i < styles.length; i++) {
      // get text content for each css file
      const stylesString = await axios.get(styles[i].href)
      // create style block
      const customStyles = document.createElement('style')
      customStyles.type = 'text/css'
      customStyles.id = `custom-css-${i}`
      // replace color values & append to the head of the document
      customStyles.appendChild(document.createTextNode(replaceColors(stylesString.data)))
      head.appendChild(customStyles)
    }
    // }
  },

  /**
   * Servicio para Loguearse en la App
   * @param {*} data Form User Data
   */
  async login ({
    commit, dispatch, rootState
  }, data) {
    try {
      commit('SET_2FA_CREDENTIALS', data)
      const response = await axios({
        method: 'POST',
        url: '/session',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          password: btoa(data.password),
          username: btoa(data.username),
          responseCaptcha: data.responseCaptcha,
          projectName: data.urlIn
        }
      })
      const user = {
        data: response.data,
        authToken: response.headers.authorization,
        isActive: true
      }
      const jwt = response.headers.authorization
      axios.defaults.headers.common.Authorization = jwt
      commit('ACTIVE_USER_STATE', user)
      commit('JWT_STATE', jwt)
      commit('URL_IN_STATE', data.urlIn)
      if (user.data.projects && user.data.projects.length === 1 && user.data.projects[0].personalization) {

        let clientp = ''
        let clients = ''
        let clientbg = ''
        let logo = ''
        // Obtener personalización del proyecto del usuario
        if(user.data.projects[0].personalization.primaryColor && user.data.projects[0].personalization.secondaryColor){
          clientp = user.data.projects[0].personalization.primaryColor
          clients = user.data.projects[0].personalization.secondaryColor
          logo = user.data.projects[0].personalization.logo
        } else {
          // Colores por defecto
          clientp = '#2E6C99'
          clients = '#1376bd'
        }

        // Color fondo: color primario con transparencia
        const colorHSL = HEXtoHSL(clientp)
        clientbg = HSLToHex(colorHSL.h, colorHSL.s-5, 97)

        commit('PRIMARY_COLOR_STATE', clientp)
        commit('SECONDARY_COLOR_STATE', clients)
        commit('CLIENTBG_COLOR_STATE', clientbg)
        commit('LOAD_LOGO', logo)        
        
      }
      // Si le metemos un CSS
      /* if (data.css && data.css !== null) {
        // dispatch('setLocalTheme', data.css).then(e => dispatch('addCustomStylesheet'))
      } else {
        // Si el usuario tiene un proyecto y esta en la tabla de personalizacion
         if (user.data.projects && user.data.projects.length === 1 && user.data.projects[0].personalization) {
          dispatch('setLocalTheme', user.data.projects[0].personalization.filename).then(e => dispatch('addCustomStylesheet'))
        } else {
          dispatch('removeLocalTheme').then(e => dispatch('removeCustomStyleSheet'))
        }
      } */
      if (rootState.session.activeUser.data.isSuperAdmin) {
        dispatch('datesSuperAdmin')
      }

      return response
    } catch (error) {
      console.log('ERROR --- 2 ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para verificar código de doble factor de autenticación en la App
   * @param {*} data Form TwoFactorAuth Data
   */
    async twoFactorAuth ({
      commit, dispatch, rootState
    }, data) {
      try {
        const response = await axios({
          method: 'POST',
          url: '/session/verify2fa',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
          data: {
            password: btoa(data.password),
            username: btoa(data.username),
            token2fa:btoa( data.token2fa),
            responseCaptcha: data.responseCaptcha,
            projectName: data.urlIn
          }
        })
        const user = {
          data: response.data,
          authToken: response.headers.authorization,
          isActive: true
        }
        const jwt = response.headers.authorization
        axios.defaults.headers.common.Authorization = jwt
        commit('ACTIVE_USER_STATE', user)
        commit('JWT_STATE', jwt)
        commit('URL_IN_STATE', data.urlIn)
        commit('CLEAN_2FA_CREDENTIALS')
        if (user.data.projects && user.data.projects.length === 1 && user.data.projects[0].personalization) {
  
          let clientp = ''
          let clients = ''
          let clientbg = ''
          let logo = ''
          // Obtener personalización del proyecto del usuario
          if(user.data.projects[0].personalization.primaryColor && user.data.projects[0].personalization.secondaryColor){
            clientp = user.data.projects[0].personalization.primaryColor
            clients = user.data.projects[0].personalization.secondaryColor
            logo = user.data.projects[0].personalization.logo
          } else {
            // Colores por defecto
            clientp = '#2E6C99'
            clients = '#1376bd'
          }
  
          // Color fondo: color primario con transparencia
          const colorHSL = HEXtoHSL(clientp)
          clientbg = HSLToHex(colorHSL.h, colorHSL.s-5, 97)
  
          commit('PRIMARY_COLOR_STATE', clientp)
          commit('SECONDARY_COLOR_STATE', clients)
          commit('CLIENTBG_COLOR_STATE', clientbg)
          commit('LOAD_LOGO', logo)        
          
        }
        if (rootState.session.activeUser.data.isSuperAdmin) {
          dispatch('datesSuperAdmin')
        }
  
        return response
      } catch (error) {
        console.log('ERROR --- 2 ', error.response)
        throw error.response
      }
    },

  /**
   * Servicio para Salir de la App
   *
   */
  async logout ({
    dispatch
  }, url) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/session'
      })
      console.log('RESPONSE:: ', response)
      commit('CLEAN_2FA_CREDENTIALS')
      console.log('Volver url2 ', url)
      dispatch('resetSession')
      // sessionStorage.clear()
      console.log('Volver url ', url)
      //router.push({ path: url }).catch(() => {})
      return response
    } catch (error) {
      console.log('ERROR --- 3 ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para Resetear la Contraseña (Step 1)
   * @param {*} data Form User Data
   */
  async resetPassChallenge ({ commit }, data) {   // Primer argumento {} es obligatorio
    if(data && data.username){
      try {
        const response = await axios({
          method: 'GET',
          url: '/forgottenpassword/challenge',
          params: {
            username: data.username
          }
        })
        console.log('RESPONSE:: ', response)
        const user = response.data
        return user
      } catch (error) {
        console.log('ERROR --- 4 ', error.response)
        throw error.response
      }
    } else {
      console.log('ERROR resetPassChallenge:: No username')
    }

  },

  async chargeUrlIn ({ commit }, urlIn) {
    commit('URL_IN_STATE', urlIn)
  },

  /**
   * Servicio para Resetear la Contraseña (Step 2)
   * @param {*} data Form User Data
   */
  async resetPassChallengeSolved ({ commit }, data) {   // Primer argumento {} es obligatorio
    if(data && data.username){
      try {
        const response = await axios({
          method: 'POST',
          url: '/forgottenpassword/challenge',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
          data: {
            username: data.username,
            email: data.email,
            responseCaptcha: data.responseCaptcha
          }
        })
        console.log('RESPONSE:: ', response)
        return response
      } catch (error) {
        console.log('ERROR --- 5 ', error.response)
        throw error.response
      }
    } else {
      console.log('ERROR resetPassChallengeSolved:: No username')
    }
  },

  loader ({ commit }, actions) {
    commit('SET_LOADER', actions)
  },
  localprojectAction: ({ commit }, payload) => {
    commit('LOCAL_PROJECT', payload)
  },
  loadLogoMenuAction: ({ commit }, payload) => {
    commit('LOAD_LOGO', payload)
  }
}

// mutations
const mutations = {
  'SET_LOADER' (state, actions) {
    state.local.loading = actions.loader === true
    state.local.isPasswordText = actions.password === true
  },
  'LOCAL_PROJECT' (state, payload) {
    state.local.localproject = payload
  },
  'LOAD_LOGO' (state, payload) {
    state.local.loadmenulogo = payload
  },
  'SET_2FA_CREDENTIALS' (state, credentials) {
    state.local.username = credentials.username
    state.local.password = credentials.password
  },
  'CLEAN_2FA_CREDENTIALS' (state) {
    state.local.username = ''
    state.local.password = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
